module.exports = __webpack_public_path__ + "static/media/face-sad.b90d822c.svg";